import { Component, OnInit, OnDestroy, ChangeDetectorRef, Injector, inject, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '../../../../../../shared/app-component-base';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../../../../../test/service/login.service';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

const ABP_DEMO_PARAMS = {
	EMAIL: '',
	PASSWORD: ''
};

@Component({
	selector: 'kt-login-form',
	templateUrl: './login-form.component.html',
	styleUrls: ['./login-form.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LoginFormComponent extends AppComponentBase implements OnInit, OnDestroy {

	loginForm: FormGroup;
	loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


	isLoggedIn$: Observable<boolean>;
	errors: any = [];

	private unsubscribe: Subject<any>;
	private returnUrl: any;


	constructor(
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		public _loginService: LoginService,
		injector: Injector
	) {

		super(injector);

	}


	ngOnInit(): void {
		this.initLoginForm();

		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params.returnUrl || '/';
		});
	}


	ngOnDestroy(): void {
		//this.authNoticeService.setNotice(null);
		// this.unsubscribe.next();
		// this.unsubscribe.complete();
		// this.loading$.next(false);
	}


	/**
	 * Form init,
	 * Defautl degerler ve validation kurallari set edilir.
	 */
	initLoginForm() {
		// if (!this.authNoticeService.onNoticeChanged$.getValue()) {
		// 	const initialNotice = `Use account
		// 	<strong>${ABP_DEMO_PARAMS.EMAIL}</strong> and password
		// 	<strong>${ABP_DEMO_PARAMS.PASSWORD}</strong> to continue.`;
		// 	this.authNoticeService.setNotice(initialNotice, 'info');
		// }

		this.loginForm = this.fb.group({
			username: [ABP_DEMO_PARAMS.EMAIL, Validators.compose([
				Validators.required,
				//Validators.email,
				Validators.minLength(3),
				Validators.maxLength(50) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [ABP_DEMO_PARAMS.PASSWORD, Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(50)
			])
			]
		});
	}


	submit(): void {
		const controls = this.loginForm.controls;

		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading$.next(true);

		const authData = {
			username: controls.username.value,
			password: controls.password.value
		};

		this._loginService.loginToServer(
			authData.username,
			authData.password,
			() => {

				this.loading$.next(false)
			},
			//undefined,
			() => {

				this.loading$.next(false)
				this.loginFinally('app/dashboard');
			}
		);


	}

	loginFinally(userDefaultUrl): void {

		//Buradaki adres, login olan kullanicinin defaultUrl degeri olmalidir.
		//Hasan
		this.router.navigateByUrl(userDefaultUrl);
	}

	/**
	   * Checking control validation
	   *
	   * @param controlName: string => Equals to formControlName
	   * @param validationType: string => Equals to valitors name
	   */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}


}
